import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { StyledSearchFacetSectionCountAndSave } from '../../patterns/search-facets/search-facets.styles'
import { SAVE_SEARCH_BUTTON_HEIGHT, SAVE_SEARCH_BUTTON_WIDTH } from '../../constants/styling'

export const SkeletonResultsCountAndSaveSearchSection = () => {
    return (
        <StyledSearchFacetSectionCountAndSave>
            <Skeleton
                style={{
                    width: SAVE_SEARCH_BUTTON_WIDTH,
                    height: SAVE_SEARCH_BUTTON_HEIGHT,
                    borderRadius: '5px',
                }}
            />
            <Skeleton
                style={{
                    width: SAVE_SEARCH_BUTTON_WIDTH,
                    height: SAVE_SEARCH_BUTTON_HEIGHT,
                    borderRadius: '5px',
                }}
            />
        </StyledSearchFacetSectionCountAndSave>
    )
}
